import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Constants from "@/shared/constants";
import store from "../store";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "*",
    redirect: "/404"
  },
  {
    path: "/403",
    name: "403",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "403" */ "@/views/Unauthorized.vue"),
    meta: {
      title: "Unauthorized"
    }
  },
  {
    path: "/404",
    name: "404",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "404" */ "@/views/NotFound.vue"),
    meta: {
      title: "Page not found"
    }
  },
  {
    path: "/invoice-volume",
    name: "Invoice Volume",
    component: () =>
      import(
        /* webpackChunkName: "Invoice Volume" */ "@/views/InvoiceVolume.vue"
      ),
    meta: {
      requiresAuth: true,
      title: "Invoice Volume"
    }
  },
  {
    path: "/recognition",
    name: "Recognition",
    component: () =>
      import(/* webpackChunkName: "recognition" */ "@/views/Recognition.vue"),
    meta: {
      requiresAuth: true,
      title: "Recognition"
    }
  },
  {
    path: "/invoices",
    name: "Invoice List",
    component: () =>
      import(/* webpackChunkName: "Invoice List" */ "@/views/InvoiceList.vue"),
    meta: {
      requiresAuth: true,
      title: "Invoice List"
    }
  },
  {
    path: "/recognition-analytics",
    name: "Recognition Analytics",
    component: () =>
      import(/* webpackChunkName: "Analytics" */ "@/views/Analytics.vue"),
    meta: {
      requiresAuth: true,
      title: "Recognition Analytics"
    }
  },
  {
    path: "/",
    name: "Home",
    component: () => import(/* webpackChunkName: "home" */ "@/views/Home.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.NODE_ENV === "production" ? process.env.BASE_URL : "/",
  routes
});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const authenticated = store.getters["AuthStore/getUserAuthenticationState"];

  if (requiresAuth && !authenticated) {
    // user not authenticated, redirect to unauthorized page
    next({ path: "/403" });
  } else if (requiresAuth && authenticated) {
    // user authenticated, proceed to route
    next();
  } else {
    // route doesn't require auth, proceed to route
    next();
  }

  document.title = !to.meta.title
    ? Constants.WEBSITE_NAME
    : `${Constants.WEBSITE_NAME} - ${to.meta.title}`;
});

export default router;
